import { SuretyQuoteStatus } from "@inrev/common";
import { useFetchBondRequestPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getRequestsTableColumns } from "./columns";

export const BondRequestPreviewsOpen: FC = () => {
	const { bondRequestPreviews } = useFetchBondRequestPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();

	const openBondRequestPreviews = useMemo(() => {
		if (!bondRequestPreviews) return undefined;
		return [...bondRequestPreviews].filter(
			({ status }) => status !== SuretyQuoteStatus.closed && status !== SuretyQuoteStatus.declined,
		);
	}, [bondRequestPreviews]);

	const columns = useMemo(() => getRequestsTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bond_requests_open_v2"
			columnDefs={columns}
			getRowUrl={(row) => `/accounts/${row.accountId}/requests/${row.id}`}
			data={openBondRequestPreviews}
			loadingMessage="Loading bond requests..."
			enableExportToCSV
		/>
	);
};
